module.exports = __webpack_public_path__ + "media/images/icon__close--rb-dark-gray-a2cdb35b9433b52d50ab4a983d10517a.png";